import React from 'react';
import { Button } from '@/components/ui/button';
import { useConsent } from '@/contexts/ConsentContext';

const ConsentBanner: React.FC = () => {
  const { acceptAll, rejectAll, openModal } = useConsent();

  return (
    <div
      role="dialog"
      aria-labelledby="consent-banner-title"
      className="fixed bottom-0 inset-x-0 z-50 border-t border-border bg-card p-4 shadow-lg"
    >
      <div className="container mx-auto max-w-4xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <h2
            id="consent-banner-title"
            className="text-sm font-semibold text-foreground mb-1"
          >
            Cookie preferences
          </h2>
          <p className="text-sm text-muted-foreground">
            We use analytics cookies for error monitoring and service reliability
            (Sentry, Google Analytics). Strictly necessary cookies are always active.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <Button variant="ghost" size="sm" onClick={openModal}>
            Customise
          </Button>
          <Button variant="outline" size="sm" onClick={rejectAll}>
            Reject all
          </Button>
          <Button size="sm" onClick={acceptAll}>
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
